import { Component } from 'react'

import * as h from 'h'

import FacultyList from 'components/FacultyList'
import AnimatedLincusLogo from './AnimatedLincusLogo'

import styles from './styles-expertise-resultitem.scss'

export default class ExpertiseResultItem extends Component {
  render () {
    const keywordHints = this.props.keywordHints || []
    const faculties = this.props.facultyHints || []

    return h.div(h.ca(styles.container),
      keywordHints.length > 0 && h.div(h.ca(styles.keywordHintsContainer),
        h.h3(null, 'Expertise Keywords'),
        h.div(null,
          h.ul(h.ca(styles.hints),
            keywordHints.map(hint =>
              h.li({ key: hint.id }, h.l({ to: `/expertise?search=${hint.keyword}` }, hint.keyword)))),
          h.h(AnimatedLincusLogo))),
      faculties.length > 0 && h.div(h.ca(styles.facultyHintsContainer),
        h.h3(null, 'Faculty'),
        h.h(FacultyList, { faculties }))
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Search/ExpertiseResultItem.js